import script from "./historialProcesosForm.vue?vue&type=script&setup=true&lang=js"
export * from "./historialProcesosForm.vue?vue&type=script&setup=true&lang=js"

import "./historialProcesosForm.vue?vue&type=style&index=0&id=29e40169&scoped=true&lang=css"
import "./historialProcesosForm.vue?vue&type=style&index=1&id=29e40169&lang=css"
import "./historialProcesosForm.vue?vue&type=style&index=2&id=29e40169&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29e40169"]])

export default __exports__